"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var observable_1 = require("../player/observable");
var DownloadState;
(function (DownloadState) {
    DownloadState[DownloadState["Queued"] = 0] = "Queued";
    DownloadState[DownloadState["Paused"] = 1] = "Paused";
    DownloadState[DownloadState["Downloading"] = 2] = "Downloading";
    DownloadState[DownloadState["Downloaded"] = 3] = "Downloaded";
    DownloadState[DownloadState["Failed"] = 4] = "Failed";
    DownloadState[DownloadState["Expired"] = 5] = "Expired";
    DownloadState[DownloadState["Deleting"] = 6] = "Deleting";
    DownloadState[DownloadState["Suspended"] = 7] = "Suspended";
})(DownloadState = exports.DownloadState || (exports.DownloadState = {}));
var Downloads = (function () {
    function Downloads() {
        this.downloadListChangedObservable = new observable_1.Observable();
        this.downloadStateChangedObservable = new observable_1.Observable();
        this.downloadProgressChangedObservable = new observable_1.Observable();
        this.downloadErrorObservable = new observable_1.Observable();
    }
    Downloads.prototype.notifyDownloadListChanged = function (downloadList) {
        this.downloadListChangedObservable.notifyObservers(downloadList);
    };
    Downloads.prototype.notifyDownloadStateChanged = function (download) {
        this.downloadStateChangedObservable.notifyObservers(download);
    };
    Downloads.prototype.notifyDownloadProgressStateChanged = function (download) {
        this.downloadProgressChangedObservable.notifyObservers(download);
    };
    Downloads.prototype.notifyDownloadError = function (error) {
        this.downloadErrorObservable.notifyObservers(error);
    };
    Downloads.prototype.onDownloadListChanged = function (callback, owner) {
        this.downloadListChangedObservable.registerObserver(callback, owner);
    };
    Downloads.prototype.onDownloadStateChanged = function (callback, owner) {
        this.downloadStateChangedObservable.registerObserver(callback, owner);
    };
    Downloads.prototype.onDownloadProgressChanged = function (callback, owner) {
        this.downloadProgressChangedObservable.registerObserver(callback, owner);
    };
    Downloads.prototype.onDownloadError = function (callback, owner) {
        this.downloadErrorObservable.registerObserver(callback, owner);
    };
    Downloads.prototype.removeEventListeners = function (owner) {
        this.downloadListChangedObservable.unregisterObservers(owner);
        this.downloadStateChangedObservable.unregisterObservers(owner);
        this.downloadProgressChangedObservable.unregisterObservers(owner);
        this.downloadErrorObservable.unregisterObservers(owner);
    };
    return Downloads;
}());
exports.Downloads = Downloads;
